export default "__VITE_ASSET__0q_oS6BX__"